import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import { Form, Radio, Input, Select, Dropdown, Loader } from "semantic-ui-react";
import "../CreateASparkModal/CreateASparkModal.css";
import CKEditor from "react-ckeditor-component";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../../../UIComponents/Modal";

class SocialInfoModal extends Component {
    render() {
        return (
            <Modal className="create-spark-modal socialInfoModal" show={this.props.open} onClose={() => this.props.toggleSocialInfoModal(false)}>
                <Modal.Header>SOCIAL DATA</Modal.Header>
                <Modal.Content>
                    <p style={{ lineHeight: "30px", fontFamily: "sans-serif", fontWeight: "100" }}>
                        When you authenticate with your Facebook and Instagram accounts, you help us to collect more Facebook and Instagram data for your
                        queries and in a more consistent manner. Without this, we will not be able to provide a good coverage of Facebook and Instagram data for
                        you.
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton onClick={() => this.props.toggleSocialInfoModal(false)}>Ok</Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default SocialInfoModal;
